import { ArrowUpRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const STEPS = [
  { n: "01", title: "Add Your Destination", copy: "Destinations, hotels, activities and transfers." },
  { n: "02", title: "Build Your Catalogue", copy: "Products, content, images and pricing, organized." },
  { n: "03", title: "Create Packages", copy: "Day-by-day itineraries from your own products." },
  { n: "04", title: "Configure Pricing", copy: "Base pricing, occupancy, add-ons, markup, seasons." },
  { n: "05", title: "Publish", copy: "Your branded website and destination storefront." },
  { n: "06", title: "Capture Enquiries", copy: "Requests land directly in your workspace." },
  { n: "07", title: "Create Quotations", copy: "Professional branded proposals, sent in minutes." },
  { n: "08", title: "Convert & Grow", copy: "Track customers, enquiries and performance." },
];

export default function HowItWorksStrip() {
  return (
    <section className="border-y border-sand bg-parch py-24 lg:py-28">
      <div className="container-x">
        <Reveal><Chapter index={6} label="How It Works" /></Reveal>
        <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
          <Reveal>
            <h2 className="max-w-xl font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              From destination supply to sale — in one workflow.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <a href="/how-it-works" data-testid="hiw-strip-link" className="group inline-flex items-center gap-2 text-sm font-bold text-terra hover:text-ink">
              Full interactive journeys
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.05 * i}>
              <div data-testid={`hiw-step-${s.n}`} className="group h-full rounded-2xl border border-sand bg-white p-6 transition-all duration-500 hover:-translate-y-1 hover:border-terra/50">
                <span className="font-mono text-xs font-bold tracking-[0.2em] text-terra">{s.n}</span>
                <h3 className="mt-3 text-base font-bold leading-snug text-ink">{s.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-stone2">{s.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
